import { render, staticRenderFns } from "./c_home_title.vue?vue&type=template&id=44251cec&scoped=true"
import script from "./c_home_title.vue?vue&type=script&lang=js"
export * from "./c_home_title.vue?vue&type=script&lang=js"
import style0 from "./c_home_title.vue?vue&type=style&index=0&id=44251cec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44251cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44251cec')) {
      api.createRecord('44251cec', component.options)
    } else {
      api.reload('44251cec', component.options)
    }
    module.hot.accept("./c_home_title.vue?vue&type=template&id=44251cec&scoped=true", function () {
      api.rerender('44251cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_title.vue"
export default component.exports